/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import './ColorKey.scss';

export type ColorKeyType = 'rh' | 'rs' | 'ppm' | 'off';

interface ColorKeyProps {
  variant: ColorKeyType;
}

const ColorKey = ({ variant }: ColorKeyProps) => {
  return (
    <div className={`color-key ${variant}`}>
      <div className="stripe" />
    </div>
  );
};

export default ColorKey;
